export default {
    CONF_ALL_LIST: 'CONF_ALL_LIST',
    ADD_CONFIG: 'ADD_CONFIG',
    GET_CONFIG_DETAILS: "GET_CONFIG_DETAILS",
    ADD_MASTER_DATA: "ADD_MASTER_DATA"
}